
import FlexibleSectionMixin from '~/mixins/flexible-section';

export default {
    mixins: [FlexibleSectionMixin],
};
